var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.607,
    height: 18.389,
    viewBox: "0 0 20.607 18.389",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11123",
    "data-name": "Path 11123",
    d: "M14.443,18.389H6.164a2.024,2.024,0,0,1-1.753-1.012l-4.14-7.17a2.024,2.024,0,0,1,0-2.024l4.14-7.17A2.024,2.024,0,0,1,6.164,0h8.279A2.024,2.024,0,0,1,16.2,1.012l4.14,7.17a2.024,2.024,0,0,1,0,2.024l-4.14,7.17a2.024,2.024,0,0,1-1.753,1.012M7.333,14.34h5.942l2.971-5.146L13.275,4.049H7.333L4.362,9.194Z",
    transform: "translate(0)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfig);
export default __webpack_public_path__ + "static/media/config.a0ab8ba13af98e66eacdbca69fc8b79f.svg";
export { ForwardRef as ReactComponent };